const roleAssociates = {
  depot_manager: {
    gate_ids: [],
    dock_ids: [],
  },
  gate_manager: {
    depot_ids: [],
    dock_ids: [],
  },
  dock_manager: {
    depot_ids: [],
    gate_ids: [],
  },
  super_admin: {
    gate_ids: [],
    dock_ids: [],
  },
  admin: {
    gate_ids: [],
    dock_ids: [],
  },
  data_entry_operator: {
    depot_ids: [],
    dock_ids: [],
  },
  gate_supervisor: {
    depot_ids: [],
    dock_ids: [],
  },
  security: {
    depot_ids: [],
    dock_ids: [],
  },
  default: {
    gate_ids: [],
    dock_ids: [],
  },
};

const gateAccessRoleTypes = ['gate_manager', 'security', 'gate_supervisor', 'data_entry_operator'];

module.exports = { gateAccessRoleTypes, roleAssociates };
